import React, { useState, useEffect } from "react";
import { Select, Tooltip } from "antd"
import { useRequest } from "ahooks"
import { getDashboardCosMajorsAPI } from "@/services"

interface IProps{
    projectID: number | string;
    onChange?: (option: API.Project.DashboardCostMajor[]) => void;
}
type MajorOption = API.Project.DashboardCostMajor & {
    label: string,
    value: string,
}
const Index: React.FC<IProps> = (props) => {
    const { projectID, onChange } = props
    const [selectedDeparts, setSelectedDeparts] = useState<MajorOption[]>([])

    const { data: majors = [] } = useRequest(async (projectID) => {
        let res = await getDashboardCosMajorsAPI(projectID)
        return res.map(v => ({ ...v, label: `${v.professionComName}-${v.professionDeptName}-${v.professionName}`, value: `${v.professioncomcode},${v.professiondeptcode},${v.profession}` }))
    }, {
        defaultParams: [projectID],
        onSuccess: (data) => {
            if(!data || data.length <= 0) return
            setSelectedDeparts(data)
            onChange && onChange(data)
        }
    })
    
    const onDepartChange = (val: string[], option: any) => {
        setSelectedDeparts(option as MajorOption[])
        onChange && onChange(option as MajorOption[])
    }

    return (
        <Select
            mode='multiple'
            className="w-[460px]"
            placeholder='按部门专业筛选'
            options={majors}
            value={selectedDeparts.map(v=>v.value)}
            onChange={onDepartChange}
            maxTagCount='responsive'
            maxTagPlaceholder={(omittedValues) => (
                <Tooltip
                    styles={{ root: { pointerEvents: 'none' } }}
                    title={omittedValues.map(({ label }) => label).join(', ')}
                >
                    <span>+ {omittedValues.length} ...</span>
                </Tooltip>
            )}
        />
    )
}
export default Index